import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var FloatingPanelService = /** @class */ (function () {
    function FloatingPanelService() {
        this.tabList = [];
        this.listOfTabs = new Subject();
        this.listOfTabsChanged$ = this.listOfTabs.asObservable();
    }
    FloatingPanelService.prototype.pushNewTab = function (id, title) {
        var result = "";
        if (this.tabList.length > 2) {
            result = "error: more than 3";
        }
        else {
            if (!this.tabList.find(function (x) { return x.id == id; })) {
                this.tabList.push({ id: id, title: title });
            }
            result = "success";
        }
        this.listOfTabs.next(this.tabList);
    };
    FloatingPanelService.prototype.removeTab = function (id) {
        if (this.tabList.find(function (x) { return x.id == id; })) {
            this.tabList.splice(this.tabList.findIndex(function (x) { return x.id == id; }), 1);
            this.listOfTabs.next(this.tabList);
        }
    };
    FloatingPanelService.ngInjectableDef = i0.defineInjectable({ factory: function FloatingPanelService_Factory() { return new FloatingPanelService(); }, token: FloatingPanelService, providedIn: "root" });
    return FloatingPanelService;
}());
export { FloatingPanelService };
